(function() {

  var collSlider = function() {

    $('.index--coll-slider').each(function(){
      var slideItem = $(this).find('.collSlider');
      var arrowLeft = $(this).find('.leftClickDesktop');
      var arrowRight = $(this).find('.rightClickDesktop');
      slideItem.not('.slick-initialized').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: arrowLeft,
        nextArrow: arrowRight,
        cssEase: 'ease-in-out',
        speed: 500,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              prevArrow: arrowLeft,
              nextArrow: arrowRight,
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              prevArrow: arrowLeft,
              nextArrow: arrowRight,
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
    }); 

  };
  
var thumbnailsSlider = function(){ 
      $('.thumbnailsSlider').slick({ 
        slidesToShow: 6,
        slidesToScroll: 1,
        vertical:true,
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-angle-up"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fas fa-angle-down"></i></button>',
        responsive: [
          {
            breakpoint: 769,
            settings: "unslick"
          } 
        ]
      });  
  }
 
 collSlider();
 thumbnailsSlider();

  $(document).on('shopify:section:load', function(event) { 
   collSlider();
   thumbnailsSlider();
  });
}());


$(document).ready(function() {
  $('.announcement-bar').slick({
    autoplay:true,
    vertical: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  });
});


jQuery(window).scroll(function(){
  var sticky = jQuery('header'),
      scroll = jQuery(window).scrollTop();

  if (scroll >= 30) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});

  $(document).ready(function(){
  $('.reviews-slider').slick({
    slidesToShow: 3,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    dots: false,
      responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
});


  $(document).ready(function(){
  $('.publication-slider').slick({
    slidesToShow: 5,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
      responsive: [
   {
      breakpoint: 768,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
});


$(document).ready(function(e) 
{
	$("a.open-bio").click(function() 
	{
		$(this).nextAll('.bio-more').first().toggle();
		$(this).toggleClass('active');
		return false;
	});
  
  jQuery('a[href^="http"]').not('a[href^=""]').attr('target', '_blank');
                                
  $(document).on('click','.drawer--right .continue',function(e){
  	e.preventDefault();
     $('.drawer__close-button').trigger('click');
  })
                                
});


// $('.template-product .no-links .publication-section').insertAfter('.info-bar-wrap'); 
  
  
  if(window.outerWidth < 768) {
  $('.site-footer .grid .large--one-quarter:last-child').prependTo('.site-footer .grid');
  $('.site-footer .social-icons').prependTo('.site-footer__copyright-content');  
    
  }
 

jQuery(document).ready(function(e) {
  
jQuery(".hs-sticky-cart-cart-drawer.hs-animated.HsbounceIn").prependTo("header");
  
  jQuery('.usa-flag').click(function(){
  jQuery('.mfp-bg,.mfp-wrap').addClass("usa");
  jQuery('.mfp-container').addClass("remove-spacing");  
  $('html').css('overflow', 'visible');
  $('html').css('margin-right', '0');
});
  
  jQuery('.search-p').click(function(){
  jQuery('.mfp-bg,.mfp-wrap').removeClass("usa");
  });
  
});




